export const css = {
	root: '_1i2weClC',
	title: 'OZkk6xEG',
	body: '_3jHss6v4',
	warning: '_1OfwyfH1',
	' _key': 'learning-activity/activity'
};

export default css;
